import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetOrderDetailRequestDto } from "../../dtos/get-order-detail-request-dto";
import type { GetOrderDetailResponseDto } from "../../dtos/get-order-detail-response-dto";
import { OrderQueryKeys } from "../../generators/order-query-keys";
import { OrderService } from "../../services/order-service";

type UseGetOrderDetailQueryParams = {
  queryParams: GetOrderDetailRequestDto;
  options?: Omit<UseQueryOptions<GetOrderDetailResponseDto>, "queryKey">;
};

export const useGetOrderDetailQuery = ({
  queryParams,
  options
}: UseGetOrderDetailQueryParams) => {
  return useQuery({
    queryKey: OrderQueryKeys.getOrderDetail(queryParams.orderId).queryKey,
    queryFn: async () =>
      await OrderService.getOrderDetail({ payload: queryParams }),
    ...options
  });
};
